/**
 * @generated SignedSource<<3e830e48410d81e9ebc07d852e694a17>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTaskMultipleRenderTaskText_taskExecutionText$data = {
  readonly textValue: string | null;
  readonly " $fragmentType": "WidgetTaskMultipleRenderTaskText_taskExecutionText";
};
export type WidgetTaskMultipleRenderTaskText_taskExecutionText$key = {
  readonly " $data"?: WidgetTaskMultipleRenderTaskText_taskExecutionText$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskMultipleRenderTaskText_taskExecutionText">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTaskMultipleRenderTaskText_taskExecutionText",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "textValue",
      "storageKey": null
    }
  ],
  "type": "TaskExecutionText",
  "abstractKey": null
};

(node as any).hash = "322e5fa928c6f069e500c886e96e3280";

export default node;
